<app-item-panel
  [title]="title"
  (selectionChanged)="onPanelSelectionChange($event)"
  [items]="priceFilterList"
>
</app-item-panel>
